import { Onfido } from 'onfido-sdk-ui'

document.addEventListener('DOMContentLoaded', function () {
  const startOnfido = (
    token: string,
    returnUrl: string,
    containerId = 'onfido-mount'
  ) => {
    return Onfido.init({
      version: '14.83.0',
      token,
      containerId,
      steps: ['welcome', 'document', 'face', 'complete'],
      onComplete: () => {
        window.location.href = returnUrl
      }
    })
  }

  // get onfido info
  const onfidoWrapper = document.querySelector('[data-onfido]')

  if (!onfidoWrapper) return

  const token = onfidoWrapper.getAttribute('data-onfido-token')
  const returnUrl = onfidoWrapper.getAttribute('data-onfido-return-url')

  if (!token || !returnUrl) return

  // start onfido sdk
  startOnfido(token, returnUrl)
})
